<script lang="ts">
  import CardForm from '../../Cards/Form.svelte'
  import { params } from '@roxi/routify'
  import { cards } from '../../Cards/observables'
  import { map, Observable } from 'rxjs'
  import { type CardProps } from '../../Cards/CardProps'
  import AuthedUserTopBarPage from '../../Navigation/TopLevelPages/AuthedUserTopBarPage.svelte'
  type Result = { found: true; card: CardProps & { id?: string } } | { found: false }
  const result: Observable<Result> = cards.pipe(
    map((cards): undefined | (CardProps & { id?: string }) => cards?.find(card => card.id === $params.id)),
    map((result): Result => (result ? { found: true, card: result } : { found: false })),
  )
</script>

<AuthedUserTopBarPage>
  {#if !$result}
    <p>Loading...</p>
  {:else if !$result.found}
    <p>A result with that ID does not exist.</p>
  {:else}
    <CardForm initialValues={$result.card} />
  {/if}
</AuthedUserTopBarPage>
